/*@ngInject*/
const UISortIconsDirective = function (coreConstant) {

    let linkFunction = function ($scope, $elm, $attrs) {

        $scope.getIconDisabledState = function (iconSortType) {
            let columnId = $attrs.columnId,
                result;

            if ($scope.requestParams) {
                $scope.requestParams.sortType = $scope.requestParams.sortType || 'none';

                if ($scope.requestParams.key !== columnId) {
                    result = true;
                }
                else {
                    result = $scope.requestParams.sortType !== iconSortType;
                }
            }

            return result;
        };

        $scope.$on(coreConstant.event.DATAGRID_ON_RESET_HEADERS, function (evt, requestParams) {

            //only in the case that the event is applicable for that header, continue
            //otherwise just return
            if ($scope.key !== requestParams.key) {
                return;
            }
            $scope.requestParams.key = requestParams.key;
        });

        $scope.$on('$destroy', function () {

        });
    };

    return {
        restrict: 'E',
        replace: true,
        link: linkFunction,
        templateUrl: '/ui/columnSort/sortIcons.tpl.html'
    };
};

angular.module('umCore')
    .directive('uiSortIcons', UISortIconsDirective);
